module.exports = __webpack_public_path__ + "img/img5.33912ca3.jpg";